import { Pipe, PipeTransform } from '@angular/core';
import { AanvraagStatusEnum } from 'app/modules/_core/api/proxy';

@Pipe({ name: 'statusDescription' })
export class StatusDescriptionPipe implements PipeTransform {
  constructor() {}

  transform(status: AanvraagStatusEnum): string {
    switch (status) {
      case AanvraagStatusEnum.InAanmaak:
        return 'In aanmaak';
      case AanvraagStatusEnum.AanvraagAfwerken:
        return 'Aanvraag afwerken';
      case AanvraagStatusEnum.KlaarOmInTeDienen:
        return 'Klaar om in te dienen';
      case AanvraagStatusEnum.Ingediend:
        return 'Ingediend';
      default:
        return '';
    }
  }
}
